console.log('init Proteus Treatments -- 0.01')

const select_topmost_ancestor = (element, selector) => {
  if (!element) {
    return null;
  }

  // Check if the current element matches the specified selector
  if (!element.closest(selector)) {
    // If it does not match, return the current element
    return element;
  }

  // Otherwise, check its parent element recursively
  return select_topmost_ancestor(element.parentElement, selector);
};

let reveal_zip = false;

fetch("http://api.ipstack.com/check?access_key=36d6acd0400e04605fa188883ade04c1").then(response => {
  if (response.ok) {
    console.log("location info retrieved...");
    return response.json();
  } else {
    throw new Error('Network response was not ok.');
  }
}).then(location => {
  console.log("you are HERE", location.zip, location)
  if(reveal_zip || window.location.href.indexOf("reveal_zip=true") > -1){
    
    var current_url = new URL(window.location.href);
    var current_params = new URLSearchParams(current_url.search);
    
    // add/set the new query parameter 
    current_params.set("zip", location.zip);
    current_url.search = current_params.toString();
    window.history.pushState({}, '', current_url.toString());
  }

  let dev_zip = getParam("zip-partial") || "995";
  let zip_partials = [dev_zip, "995", "352", "357", "852", "853", "857", "850", "851", "947", "926", "928", "945", "907", "917", "919", "940", "950", "920", "957", "956", "923", "913", "906", "902", "925", "930", "911", "949", "921", "941", "951", "944", "954", "905", "953", "927", "800", "806", "801", "809", "802", "805", "804", "068", "064", "069", "066", "200", "339", "322", "335", "330", "341", "320", "334", "300", "303", "305", "301", "308", "967", "528", "503", "837", "601", "604", "606", "600", "605", "460", "461", "660", "662", "672", "402", "023", "017", "014", "027", "021", "020", "024", "015", "018", "214", "210", "207", "206", "217", "208", "212", "209", "211", "481", "495", "488", "480", "483", "553", "551", "554", "550", "559", "630", "633", "641", "631", "275", "282", "280", "281", "276", "681",  "38", "030", "080", "070", "079", "085", "088", "078", "077", "089", "076", "074", "087", "891", "117", "120", "118", "105", "119", "128", "109", "103", "115", "145", "106", "442", "452", "432", "431", "430", "451", "450", "970", "971", "972", "190", "160", "180", "193", "170", "194", "152", "189", "294", "370", "381", "371", "750", "787", "786", "774", "762", "775", "760", "761", "770", "773", "782", "751", "840", "841", "223", "201", "229", "233", "227", "220", "224", "230", "231", "232", "221", "225", "234", "226", "983", "980", "982", "993", "981", "986", "530", "540", "537", "531", "535"];
  if(zip_partials.indexOf(location.zip.slice(0,3)) > -1){
    
    console.log(`your zip (${location.zip}) was found in zip_partials`)
    if(!window.sessionStorage.getItem("Tvsp7w shown")){
      window.sessionStorage.setItem("Tvsp7w shown", true);
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'Tvsp7w']);

      observeSelector('form[data-testid="klaviyo-form-VR82YB"]', og_form_desktop => {
        console.log("og_form seen + removed")
        
        //select_topmost_ancestor(og_form_desktop, '.needsclick[class*="kl-"]').remove();
        // this method tracks as a closed form to prevent firing on the next page view
        select_topmost_ancestor(og_form_desktop, '.needsclick[class*="kl-"]').querySelector('.klaviyo-close-form').click();
      })

      observeSelector('form[data-testid="klaviyo-form-VbPa9Y"]', og_form_mobile => {
        console.log("og_form seen + removed")
        //select_topmost_ancestor(og_form_mobile, '.needsclick[class*="kl-"]').remove();
        // this method tracks as a closed form to prevent firing on the next page view
        select_topmost_ancestor(og_form_mobile, '.needsclick[class*="kl-"]').querySelector('.klaviyo-close-form').click();
      })

    }

    var exp_id = "BIOM-24";
    var exp_name = "Target Popup by user zip code";
    
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      'event': 'proteus_experiment_pageview',
      'proteus_exp_id': exp_id,
      'proteus_var_id': "v1",
      'proteus_exp_name': exp_name,
      'proteus_exp_version': "0.01",
    });
    
  } else {
    console.log(`your zip (${location.zip}) was NOT found in zip_partials`)
  }
    
}).catch(error => {
  console.error('There has been a problem with your fetch operation:', error);
});